/* Tea Mood – Premium PDP */
(function () {
  var d = document;
  function ready(fn) { if (d.readyState !== 'loading') { fn(); } else { d.addEventListener('DOMContentLoaded', fn); } }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }

  function reveal() {
    var els = all('[data-tmp-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  function gallery(g) {
    var slides = all('[data-tmp-slide]', g), thumbs = all('[data-tmp-thumb]', g);
    var track = g.querySelector('[data-tmp-track]'), cur = g.querySelector('[data-tmp-cur]');
    if (!slides.length || !track) { return; }
    var i = 0, mq = window.matchMedia('(min-width: 990px)'), t;
    function set(n, scroll) {
      n = (n + slides.length) % slides.length; i = n;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === n); b.setAttribute('aria-selected', k === n ? 'true' : 'false'); });
      if (cur) { cur.textContent = String(n + 1); }
      if (scroll && !mq.matches) { track.scrollTo({ left: track.clientWidth * n, behavior: 'smooth' }); }
    }
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { set(k, true); }); });
    all('[data-tmp-nav]', g).forEach(function (b) {
      b.addEventListener('click', function () { set(i + (b.getAttribute('data-tmp-nav') === 'prev' ? -1 : 1), true); });
    });
    track.addEventListener('scroll', function () {
      if (mq.matches) { return; }
      clearTimeout(t);
      t = setTimeout(function () { var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (n !== i) { set(n, false); } }, 60);
    }, { passive: true });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { set(i + 1, true); } else if (e.key === 'ArrowLeft') { set(i - 1, true); }
    });
  }

  function mainForm() { return d.querySelector('product-info'); }

  function pickers() {
    all('[data-tmp-pick]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var want = b.getAttribute('data-tmp-pick'), pi = mainForm();
        if (!pi) { return; }
        var hit = null;
        all('variant-selects input[type="radio"]', pi).forEach(function (r) { if (r.value === want) { hit = r; } });
        if (hit && !hit.checked) { hit.click(); }
        pi.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    all('[data-tmp-top]').forEach(function (b) {
      b.addEventListener('click', function (e) { var pi = mainForm(); if (pi) { e.preventDefault(); pi.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (fmt || '€{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function bar() {
    var el = d.querySelector('[data-tmp-bar]'), pi = mainForm();
    if (!el || !pi) { return; }
    var submit = pi.querySelector('.product-form__submit, button[name="add"]');
    if (!submit) { return; }
    var variants = [];
    try { variants = JSON.parse(el.getAttribute('data-variants') || '[]'); } catch (err) { variants = []; }
    var meta = el.querySelector('[data-tmp-bar-meta]'), fmt = el.getAttribute('data-money');
    function current() {
      var inp = pi.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = inp ? parseInt(inp.value, 10) : 0;
      for (var k = 0; k < variants.length; k++) { if (variants[k].id === id) { return variants[k]; } }
      return variants[0];
    }
    function update() { var v = current(); if (v && meta) { meta.textContent = v.title + ' · ' + money(v.price, fmt); } }
    update();
    d.addEventListener('change', function () { setTimeout(update, 250); });
    var past = false;
    function toggle() { el.classList.toggle('is-on', past); el.setAttribute('aria-hidden', past ? 'false' : 'true'); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; toggle(); });
      }, { threshold: 0 }).observe(submit);
    }
    var btn = el.querySelector('[data-tmp-bar-add]');
    if (btn) {
      btn.addEventListener('click', function () {
        var s = pi.querySelector('.product-form__submit, button[name="add"]');
        if (s && !s.disabled) { s.click(); } else { pi.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }
  }

  function cost() {
    all('[data-tmp-cost]').forEach(function (el) {
      var loose = parseFloat(el.getAttribute('data-loose')) || 15, bag = parseFloat(el.getAttribute('data-bag')) || 60;
      var price = parseFloat(el.getAttribute('data-price')) || 0, en = el.getAttribute('data-lang') === 'en';
      var out = el.querySelector('[data-tmp-cups]'), res = el.querySelector('[data-tmp-result]'), cups = 3;
      function render() {
        var perDay = (bag - loose) * cups;               // Cent pro Tag
        var year = Math.round(perDay * 365 / 100 / 10) * 10;
        var days = perDay > 0 ? price / perDay : 0, when;
        if (days < 56) { var w = Math.max(1, Math.round(days / 7)); when = en ? ('about ' + w + (w === 1 ? ' week' : ' weeks')) : ('etwa ' + w + (w === 1 ? ' Woche' : ' Wochen')); }
        else { var m = Math.round(days / 30.4); when = en ? ('about ' + m + ' months') : ('etwa ' + m + ' Monaten'); }
        if (out) { out.textContent = en ? (cups + (cups === 1 ? ' cup a day' : ' cups a day')) : (cups + (cups === 1 ? ' Tasse am Tag' : ' Tassen am Tag')); }
        if (res) {
          res.innerHTML = en
            ? ('That is around <b>' + year + ' € less per year</b>. The teapot has paid for itself after ' + when + '.')
            : ('Das sind rund <b>' + year + ' € weniger im Jahr</b>. Die Kanne ist nach ' + when + ' bezahlt.');
        }
      }
      all('[data-tmp-step]', el).forEach(function (b) {
        b.addEventListener('click', function () { cups = Math.min(8, Math.max(1, cups + parseInt(b.getAttribute('data-tmp-step'), 10))); render(); });
      });
      render();
    });
  }

  function prelander() {
    try {
      var m = /[?&]pl=([a-z0-9-]{1,40})/i.exec(window.location.search || '');
      if (!m) { return; }
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ attributes: { prelander: m[1] } })
      }).catch(function () {});
    } catch (err) {}
  }

  ready(function () {
    window.__tmpReady = true;
    prelander();
    reveal();
    all('[data-tmp-gallery]').forEach(gallery);
    pickers();
    bar();
    cost();
  });
})();
